import { SocialSharing } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import type { ShareAction as ShareActionType } from 'src/app/shared/hooks/share';

import { useSocialIconWithSuccessState } from './hooks/useSocialIconWithSuccessState';

type Props = {
	buttonConfig: {
		ShareAction: ShareActionType['ShareAction'];
		icon: React.ReactElement;
		label: TranslationKey;
		successLabel?: TranslationKey;
	};
	variant?: 'default' | 'facebook' | 'instagram' | 'twitter' | 'whatsapp' | 'facebookMessenger' | 'nextdoor' | 'reddit';
	size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
} & Omit<React.ComponentProps<typeof SocialSharing>, 'label' | 'icon' | 'variant' | 'size' | 'onClick'>;

export type { Props as SocialIconWithSuccessStateProps };

export const SocialIconWithSuccessState = ({
	buttonConfig: { ShareAction, icon, label, successLabel },
	variant = 'default',
	size = 'large',
	...rest
}: Props): React.ReactElement => {
	const { translate } = useI18n();
	const { data, actions } = useSocialIconWithSuccessState({ label, successLabel });

	return (
		<ShareAction onAfterAction={actions.afterShare}>
			<SocialSharing icon={icon} label={translate(data.currentLabel)} variant={variant} size={size} {...rest} />
		</ShareAction>
	);
};
